import UserEventApi from '@apis/user/UserEventApi';
import useProjectId from '@hooks/useProjectId';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

function useUpdateDau() {
    const [cookies, setCookies] = useCookies(['dauUpdated']);
    const { dauUpdated } = cookies;
    const projectId = useProjectId();
    useEffect(() => {
        if (!dauUpdated && projectId) {
            UserEventApi.updateDau(projectId)
                .then(() => {
                    const expires = dayjs().add(1, 'day')
                        .set('hour', 0)
                        .set('minute', 0)
                        .set('second', 0)
                        .toDate();
                    setCookies('dauUpdated', true, { expires });
                }).catch((e) => {
                    console.error(e);
                });
        }
    }, [dauUpdated, projectId]);
}

export default useUpdateDau;
